(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name acarsMessages.controller:AcarsMessagesCtrl
	 *
	 * @description
	 *
	 */
	angular
		.module('acarsMessages')
		.directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})
		.controller('AcarsMessagesCtrl', AcarsMessagesCtrl);

	function AcarsMessagesCtrl(CommonMasterData, EventManagerService, MessageService, AcarsMessagesFactory, AcarsMessagesService, PopupManager, $timeout, $window) {
		var vm = this;
		vm.ctrlName = 'AcarsMessagesCtrl';

		vm.model = {
				searchPanelToggle : true,
				searchCriteria : {
					flightNumber : '',
					fromDate : moment().format('DD/MM/YYYY'),
					toDate : moment().format('DD/MM/YYYY'),
					fromTime : '00:00',
					toTime : '23:59',
					origin : '',
					destination : '',
					messageStatus : '',
					pageSize: 50,
					startPosition: 1
				},
				masterList : {
					airportList : [],
					messageStatusList: [],
					fromTimeInvalid : false,
					toTimeInvalid : false,
					fromDateFormatInvalid : false,
					// 70 (title bar height) + 40 (toolbar height)+ 46 (table header)
					canvasHeight : $window.innerHeight - 156,
				},
				selectedRow : {},
				messages : [],	// grid data
		};

		angular.element($window).bind('resize', function(){
            $timeout(function () {
            	vm.model.masterList.canvasHeight = $window.innerHeight - 156;
            },0);
        });

		EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
		};

		vm.changeSearchField = function(searchParams, flag) {
			if (flag === 'fromTime') {
				if (!isValidTime(searchParams.fromTime)) {
					vm.model.masterList.fromTimeInvalid = true;
				} else {
					vm.model.masterList.fromTimeInvalid = false;
					if (!isFromDateBeforeToDate()) {
						vm.model.searchCriteria.toTime = vm.model.searchCriteria.fromTime;
					}
				}
			} else if (flag === 'toTime') {
				if (!isValidTime(searchParams.toTime)) {
					vm.model.masterList.toTimeInvalid = true;
				} else {
					vm.model.masterList.toTimeInvalid = false;
					if (!isFromDateBeforeToDate()) {
						vm.model.searchCriteria.fromTime = vm.model.searchCriteria.toTime;
					}
				}
			}
			else if (flag === 'fromDate') {
				if(!moment(searchParams.fromDate, "DD/MM/YYYY").isValid() && !!searchParams.fromDate){
					vm.model.masterList.fromDateFormatInvalid = true;
				} else {
					vm.model.masterList.fromDateFormatInvalid = false;
				}
			}else if (flag === 'toDate') {
        if(!moment(searchParams.toDate, "DD/MM/YYYY").isValid() && !!searchParams.toDate){
          vm.model.masterList.toDateFormatInvalid = true;
        } else {
          vm.model.masterList.toDateFormatInvalid = false;
        }
      }
		};

		// submit search
		vm.submitSearch = function(params) {
			if (!vm.model.masterList.fromDateFormatInvalid && !vm.model.masterList.fromTimeInvalid && !vm.model.masterList.toTimeInvalid) {
				vm.model.searchCriteria = params;
				vm.model.searchCriteria.startPosition = 1;
				document.querySelector('.acars_elastic_div').scrollTop = 0;
				AcarsMessagesService.searchAcarsMessages(vm.model.searchCriteria,
					function(messages) {
						vm.model.searchPanelToggle = false;
						vm.model.messages = AcarsMessagesFactory.getFormattedMessages(messages);
					},
					function(error) {
						MessageService.error(error);
					});
			}
		};

		function getNextSetOfRecords() {
			if (vm.model.messages && vm.model.messages.totalRecords &&
	                vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize < vm.model.messages.totalRecords) {
	                vm.model.searchCriteria.startPosition = vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize;
	                getDataForElasticSearch();
	            }
			else {
				var lastPageStartPos = vm.model.messages.totalRecords - vm.model.searchCriteria.pageSize;
                if (vm.model.searchCriteria.startPosition < lastPageStartPos) {
                    vm.model.searchCriteria.startPosition = lastPageStartPos;
                    getDataForElasticSearch();
                }
			}
		}

		function getDataForElasticSearch() {
			AcarsMessagesService.searchAcarsMessages(vm.model.searchCriteria, function(messages) {
				AcarsMessagesService.appendToGridMessagesList(vm.model.messages, AcarsMessagesFactory.getFormattedMessages(messages));
			}, function(error) {
				MessageService.error(error);
			});

		}

		function isFromDateBeforeToDate() {
			return moment(
					vm.model.searchCriteria.fromDate + " "
							+ vm.model.searchCriteria.fromTime,
					"DD/MM/YYYY HH:mm").isBefore(
					moment(vm.model.searchCriteria.toDate + " "
							+ vm.model.searchCriteria.toTime,
							"DD/MM/YYYY HH:mm"));
		}

		function isValidTime(time) {
			var regex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
			return regex.test(time);
		};

		(function() {
			// airportList
			CommonMasterData.getAirportList(function(airportList) {
				vm.model.masterList.airportList = airportList;
			}, function() {
				console.log('Airport List retrieval error');
			});

			//MessageStatus
			CommonMasterData.getAcarsMessageStatusList(function(statusList) {
				vm.model.masterList.messageStatusList = statusList;
			}, function() {
				console.log('Message Status List retrieval error');
			});
		})();
	}
}());
